import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { pricingTableDialogFeature } from './pricing-table-dialog.feature';
import { PricingTableDialogEffects } from './pricing-table-dialog.effects';

@NgModule({
  imports: [
    StoreModule.forFeature(pricingTableDialogFeature),
    EffectsModule.forFeature([PricingTableDialogEffects]),
  ],
})
export class PricingTableDialogModule {}
